import { MapPin } from '@chain-zen/ui'

import type { IStopWarehouse } from '../../../../../../types/shipment'

interface WarehouseDisplayProps {
  warehouse: IStopWarehouse | null
}

/**
 * Display component for showing warehouse information in read-only mode
 */
export const WarehouseDisplay = ({ warehouse }: WarehouseDisplayProps) => {
  if (!warehouse) return null

  return (
    <div className="space-y-1">
      {!!warehouse.address?.addressLabel && (
        <div className="flex min-w-0 items-start gap-1.5">
          <MapPin className="h-3 w-3 shrink-0 text-muted-foreground" />
          <p className="min-w-0 break-words whitespace-normal text-xs leading-4 text-muted-foreground">
            {warehouse.address.addressLabel}
          </p>
        </div>
      )}
    </div>
  )
}
